"use strict";
/**
 * Обязательно к прочтению https://www.unicode.org/cldr/charts/34/supplemental/language_plural_rules.html
 */var locales={getPlural_ru:function(r){if(0===r)return"zero";var e=r%100;if(11<=e&&e<=19)return"many";switch(e%10){case 1:return"one";case 2:case 3:case 4:return"few";default:return"many"}},getPlural_en:function(r){return 1===r?"one":"other"}};
/**
 * Возвращает нужную форму слова в зависимости от числительного, которое находится перед словом.
 * Работает для русского и английского языка, в зависимости от поля locale параметра функции
 * Русская локаль используется по умолчанию, если локаль не указана в параметре
 *
 * @param {object} pluralObj
 *
 * @returns {string}
*/function getPlural(r){var e=r.locale||"ru",t=locales["getPlural_"+e];if(!t)throw Error('Неизвестная локаль "'+e+'"');var u=r[t(r.value)];return"number"==typeof u?null:u}module.exports=getPlural;
